﻿import Page from "./Page";
import reducer from "./reducer";

export const reducers = {
  SchoolManager: reducer,
};

export default {
  Page,
  reducers,
};